import { PATHS } from '../configs';
import client from '../services/client';

import type { ChainStoreInvoice, SupportReceiptType } from '../types';

type GetTaiwanPayInitUrlProps = {
  invoice: ChainStoreInvoice;
  email: string | undefined;
  receipt: {
    name: string;
    phone: string;
    barcode?: string;
    type: SupportReceiptType;
    ubn?: string;
    donate?: string;
  };
  callbackParams: {
    serviceUid: string;
    captureMethod: string;
    amount: string;
    merchantUid: string;
  };
};

export const getTaiwanPayInitUrl = async ({
  invoice,
  email,
  receipt,
}: GetTaiwanPayInitUrlProps) => {
  const {
    data: {
      data: { redirect_link },
    },
  } = await client.initTaiwanPayTransaction({
    invoiceId: invoice.id,
    email,
    receipt,
    callbackUrl: `${window.location.origin}${PATHS.INVOICES(invoice.id).AUTH.TAIWAN_PAY}`,
  });

  return redirect_link;
};
